import type { FaireProductEntity } from "../../entity_types/product";

export const p_ga2x7x75n5: FaireProductEntity = {
  token: "p_ga2x7x75n5",
  type: "product",
  name: "Knit Sweater with Contrast Trim – Casual & Cozy",
  brandToken: "b_axnmezu6gc",
  brandName: "Suhkasana",
  imageUrl:
    "https://cdn.faire.com/fastly/690db2cde5209835daa3d5aa86f06253818c4bf48151e2834b241b5313a60765.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5503e503d76ba6909f45155594fa724b36279326b32e56e1476e9f4104a50f4d.jpeg",
    "https://cdn.faire.com/fastly/c56792dcf99a1c82b062299490f8f2254d1522c3b2a9a0dea4ac7cf2bb23f22a.jpeg",
    "https://cdn.faire.com/fastly/f963c8d03d3f00c258d03a44082bcac4d737d7077c4c14c13b103362a5f710d4.jpeg",
    "https://cdn.faire.com/fastly/88fc465aea992461446d4d762135a3cbe4a994e0081e4fd9d00d66153398b524.jpeg",
    "https://cdn.faire.com/fastly/31831dceb7db18520cdc2ebd7624f3e8365bb7e6e96ad57dfc6f14bbe5141714.jpeg",
    "https://cdn.faire.com/fastly/7a84b4267967923633965753ff4074074118b864c446a818b06586e9a2b64c1d.jpeg",
    "https://cdn.faire.com/fastly/4e135db0f5b307df24f60d18ce727c90ca5f4cc464027d53cae9ad42af9427bc.jpeg",
    "https://cdn.faire.com/fastly/98d24e37d4edb6661888fa6b67bb1b006121addebb30a5754d0af236d4dc0b82.jpeg",
    "https://cdn.faire.com/fastly/13508444cd388d312881419e32d13087ca3abc1ec86bbabdd5132133b41ac826.jpeg",
    "https://cdn.faire.com/fastly/1f741bfad1905e8f08f2ca6a8649a8749366f10c6a83582983502ccac6566fb6.jpeg",
    "https://cdn.faire.com/fastly/4028bae79d578acb3c1c99692a69aadf8649e1810884d26e334bb712beb307ce.jpeg",
    "https://cdn.faire.com/fastly/45b2dd4b5575916305235b335456e423d2557cbca9b6edbf2889046e29dd93c3.jpeg",
    "https://cdn.faire.com/fastly/946845ac1bbd98b89f1ee2c8b6e2d3c7096f3312f49fe8cb4d5ea2827f84d2fd.jpeg",
    "https://cdn.faire.com/fastly/b266228882693e83a5afab33c867268cd34ce26d4240500f4664ddc86fe2a080.jpeg",
    "https://cdn.faire.com/fastly/7b8bc074b4ee436d7ac21f038646b914eff516cbaafea0122869114e63f00fa4.jpeg",
    "https://cdn.faire.com/fastly/f2ba5c4f64673f04790668cbcc1bbbeaf130574bd7bf3558ce94fadce2edb806.jpeg",
    "https://cdn.faire.com/fastly/df6f4491aa695de819593ac37e74edccff5bb3b264e7d5cda6b9d61e5959e9a9.jpeg",
    "https://cdn.faire.com/fastly/64370b8b17ec234be8bc4e4c0c22727a4988814241c2ef5ce6f8474aca7d6d6a.jpeg",
    "https://cdn.faire.com/fastly/66ab587a9d84e5cf38b88e8b07792fabf905517132d091281e365ab78413b2c9.jpeg",
    "https://cdn.faire.com/fastly/ab20a59a2dee0f7a471f91311049456996065f6306a6ae5f7704cb2291c7ed29.png",
  ],
  priceDollars: 75.99,
  description:
    "Cozy Knit Fabric: Soft and breathable, perfect for cooler fall days. Lightweight yet warm, ideal for layering.\n\nStylish Design: Featuring a crew neck and long sleeves with chic contrast trim, adding a trendy twist to a classic look.\n\nVersatile Fit: Relaxed fit for comfort. Pairs easily with jeans, skirts, or leggings for casual or commute wear.\n \nPerfect for Fall: Ideal for everyday wear, whether at work or out with friends. Keeps you cozy and stylish.\n\nAvailable in Sizes S, M, L: Choose from a range of sizes and colors to suit your style and comfort needs.",
  tags: [],
  msrpDollars: 151.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:09.604Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
